import {
  SET_SNACKBAR,
} from "../actions/types";

const initialState = {
  snackbarOpen: false,
  snackbarType: "success",
  snackbarMessage: "",

};

export default function (state = initialState, action) {
  const { type, snackbarOpen, snackbarMessage, snackbarType } = action;

  switch (type) {
    case SET_SNACKBAR:
      return {
        ...state,
        snackbarOpen,
        snackbarType,
        snackbarMessage,
      }
    default:
      return state;
  }
}
